import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ListView, RootState } from 'model/state';
import { Dispatch } from 'redux';
import { ConsumptionView } from 'components';
import { ConsumptionFilter, FormattedConsumptionData, FormattedConsumptionTable, Location, LocationType } from 'model';
import { selectUserId, selectUserLocations } from 'selectors';
import { cleanConsumptionData, fetchConsumptionByFilters, fetchUserLocations, updateConsumptionFilters } from 'actions';
import {
  selectConsumptionFilters, selectConsumptionTableData, selectFormattedChartData, selectIsLoadingChart,
  selectRefreshButtonDisabled, selectTimezone
} from 'selectors/Consumption';


type SelectedValues = {
  userLocations: ListView<Location>,
  userId?: string | null,
  filters: ConsumptionFilter,
  consumptionData: FormattedConsumptionData,
  refreshDisabled: boolean,
  tableData: FormattedConsumptionTable,
  isLoading: boolean,
  timezone: string,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  userLocations: selectUserLocations(),
  userId: selectUserId(),
  filters: selectConsumptionFilters(),
  consumptionData: selectFormattedChartData(),
  refreshDisabled: selectRefreshButtonDisabled(),
  tableData: selectConsumptionTableData(),
  isLoading: selectIsLoadingChart(),
  timezone: selectTimezone(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchUserLocations: (userId: string, types?: LocationType[], page?: number, search?: string) => dispatch(fetchUserLocations(userId, types, page, search)),
  updateConsumptionFilters: (filters: Partial<ConsumptionFilter>) => dispatch(updateConsumptionFilters(filters)),
  fetchConsumptionByFilters: (filters: ConsumptionFilter, timezone: string, userId?: string) => dispatch(fetchConsumptionByFilters(filters, timezone, userId)),
  cleanConsumptionData: () => dispatch(cleanConsumptionData()),
});


export default connect(mapStateToProps, mapDispatchToProps)(ConsumptionView);
